export { default as version } from './version';
export { default, default as XMarkdown } from './XMarkdown';
export { default as AnimationText } from './XMarkdown/AnimationText';
export { useStreaming } from './XMarkdown/hooks';
export type {
  ComponentProps,
  StreamCacheTokenType,
  StreamStatus,
  Token,
  Tokens,
  XMarkdownProps,
} from './XMarkdown/interface.ts';
